export default "__VITE_ASSET__B6kMU7ZF__"